/* ── environment config (DEV / PROD) ─────────────────────────────────── */
export const API_ENVS = {
  dev:  "https://dev.equitypicker.com/apiv2",
  prod: "https://ai-api.investobull.com/api/ai",
};

let _env = "dev";  // default
let _baseUrl = API_ENVS[_env];

export const getApiEnv = () => _env;
export const setApiEnv = (env) => {
  if (!API_ENVS[env]) throw new Error(`Unknown env: ${env}`);
  _env = env;
  _baseUrl = API_ENVS[env];
};

/* ── helpers ────────────────────────────────────────────────────────── */
const toInstant = (dateStr, endOfDay = false) => {
  if (!dateStr) return undefined;
  if (dateStr.includes("T")) return dateStr;
  return endOfDay ? `${dateStr}T23:59:59Z` : `${dateStr}T00:00:00Z`;
};

const buildQueryString = (params) => {
  if (!params) return "";
  const query = [];
  const from = toInstant(params.from, false);
  const to   = toInstant(params.to, true);
  if (from) query.push(`from=${encodeURIComponent(from)}`);
  if (to)   query.push(`to=${encodeURIComponent(to)}`);
  if (params.granularity) query.push(`granularity=${encodeURIComponent(params.granularity)}`);
  if (params.feature)     query.push(`feature=${encodeURIComponent(params.feature)}`);
  if (params.page !== undefined && params.page !== null && params.page !== "")
    query.push(`page=${encodeURIComponent(params.page)}`);
  if (params.size !== undefined && params.size !== null && params.size !== "")
    query.push(`size=${encodeURIComponent(params.size)}`);
  return query.length > 0 ? "?" + query.join("&") : "";
};

const fetchJson = async (url) => {
  const response = await fetch(url, { method: "GET" });
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  return response.json();
};

/* ── analytics/usage endpoints ──────────────────────────────────────── */
export const getTimeSeries = async (params) => {
  const qs = buildQueryString(params);
  try {
    const data = await fetchJson(`${_baseUrl}/analytics/usage/timeseries${qs}`);
    return { status: true, data };
  } catch (error) {
    return { status: false, error: error.message };
  }
};

export const getFeatureSummary = async (params) => {
  const qs = buildQueryString(params);
  try {
    const data = await fetchJson(`${_baseUrl}/analytics/usage/features${qs}`);
    return { status: true, data };
  } catch (error) {
    return { status: false, error: error.message };
  }
};

export const getTrace = async (params) => {
  const qs = buildQueryString(params);
  try {
    const data = await fetchJson(`${_baseUrl}/analytics/usage/trace${qs}`);
    return { status: true, data };
  } catch (error) {
    return { status: false, error: error.message };
  }
};

/* ── summarize endpoints ─────────────────────────────────────────────── */
export const lookupAnnouncementByUrl = async (url) => {
  try {
    const data = await fetchJson(`${_baseUrl}/summarize/announcement-summary/lookup?url=${encodeURIComponent(url)}`);
    return { status: true, data };
  } catch (error) {
    return { status: false, error: error.message };
  }
};

// broadcastDateTime must be LocalDateTime format: "2026-08-25T09:37:21"
export const retryAnnouncementSummary = async ({ symbol, subject, broadcastDateTime, sendAlert = false }) => {
  const qs = [
    `symbol=${encodeURIComponent(symbol)}`,
    `subject=${encodeURIComponent(subject)}`,
    `broadcastDateTime=${encodeURIComponent(broadcastDateTime)}`,
    `sendAlert=${sendAlert}`,
  ].join("&");
  try {
    const response = await fetch(`${_baseUrl}/summarize/announcement-summary/manual?${qs}`, {
      method: "POST",
    });
    const data = await response.json();
    return { status: response.ok, data };
  } catch (error) {
    return { status: false, error: error.message };
  }
};
